import './styles.css';

import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import MobileInstallmentBanks from './MobileInstallmentBanks';
import WebInstallmentBanks from './WebInstallmentBanks';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          exact
          path={process.env.PUBLIC_URL}
          element={<MobileInstallmentBanks />}
        />
        <Route
          exact
          path={`${process.env.PUBLIC_URL}/web`}
          element={<WebInstallmentBanks />}
        />
      </Routes>
    </Router>
  );
};

export default App;
